import { useTranslation } from 'react-i18next';
import { Anchor } from '../../../../components/Link';
import { Thumbnail } from '../../../../components/thumbnail/thumbnail';
import { ImageProps } from '../../../../interfaces';
import { EpisodeThumbnailProps } from './episode-thumbnail';
import { SvgExternalLink, SvgCart } from '../../../../icons';

interface EpisodeThumbnailExternalLinkProps extends Pick<EpisodeThumbnailProps, 'source'> {
  image: ImageProps;
  url: string;
}

export function EpisodeThumbnailExternalLink({ source, image, url }: EpisodeThumbnailExternalLinkProps) {
  const { t } = useTranslation();

  const overlayText = source.type === 'thirdparty' ? `${t('details:open-in')} ${source.name}` : t('get access');

  return (
    <Anchor href={url} target={'_blank'} onClick={(e) => e.stopPropagation()}>
      <Thumbnail image={image} icon={source.type === 'thirdparty' ? SvgExternalLink : SvgCart} iconText={overlayText} />
    </Anchor>
  );
}
